import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawVolumeUpIcon from "./RawPresentIcon.svg.jsx";

const PresentIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawVolumeUpIcon} {...props} />;
});

export default PresentIcon;
